module.exports = __webpack_public_path__ + "media/images/logo-black-circle-small-a3d7515ffb27c4481e6016849a78782d.jpg";